const settings = {
  seatRadius: 8
}

const colors = {
  outline: 'darkgray',
  unavailable: 'lightgrey',
  categoryColors: {
    1: 'aquamarine',
    2: 'moccasin',
    3: 'lightcoral'
  }
}

export { colors, settings }